export enum VERIFY_CHANNEL {
  SMS = 'sms',
  CALL = 'call',
}
